import _ from "lodash";

export const SEASON_LIST_REQUEST = 'SEASON_LIST_REQUEST';
export const SEASON_LIST_SUCCESS = 'SEASON_LIST_SUCCESS';
var initialState = {
    byId: [],
    allIds: [],
    loading: false
};

export default (state = initialState, action) => {
    if (action.payload?.entities?.season) {
        state = {
            ...state,
            byId: _.merge(state.byId, action.payload.entities.season)
        }
    }
    switch (action.type) {
        case SEASON_LIST_REQUEST: {
            return {
                ...state,
                loading: true
            }
        }
        case SEASON_LIST_SUCCESS:
            return {
                ...state,
                allIds: action.payload.result,
                loading: false
            }
        default:
            return state;
    }
};